import triggerNavColorChange from "./nav-color-change";
import addAccordion from "./accordion";
import AOS from "aos";

AOS.init();

function openMenu() {
  function init() {
    const hamburger = document.querySelector(".hamburger");
    const menu = document.querySelector(".mobile-menu");

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });
  }

  const isPresent = document.getElementsByClassName("hamburger");
  if (isPresent.length > 0) {
    init();
  }
}

openMenu();

addAccordion();
triggerNavColorChange();
